import React from 'react';
import PropTypes from 'prop-types';

import {Link} from 'react-router';
import {connect} from 'react-redux';

import {prefixByChannel} from '../../routes/prefixes';

function ChannelLink({activeChannel, to = '', children, ...rest}) {
  return (
    <Link
      {...rest}
      to={ChannelLink.formatLink(activeChannel, to)}
    >
      {children}
    </Link>
  );
}

ChannelLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node.isRequired
};

ChannelLink.formatLink = (activeChannel, path) => {
  const prefix = prefixByChannel[activeChannel] || '';
  return `/${prefix}/${path}`.replace(/\/+/g, '/');
};

export default connect(
  ({channels}) => ({activeChannel: channels.activeChannel}),
  {}
)(ChannelLink);



// WEBPACK FOOTER //
// ./containers/channelUtils/ChannelLink.js